import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import './AppContainer.scss';
import styles from '@/components/AppContainer/AppContainer.module.scss';
import { IframeController } from '@/components/IframeController/IframeController';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { Popover, PopoverContent, PopoverTrigger, } from '@/components/ui/popover';
import { SocketContext } from '@/contexts/socket';
import { useSocketSetup } from '@/hooks/useSocketSetup';
import { useWidgetState } from '@/hooks/useWidgetState';
import { Launcher } from '@/newComponents/Launcher/Launcher';
import { autoOpenSelector, focusTrapSelector, themeSelector, widgetAlignmentSelector, widgetPositionState, } from '@/state/config';
import { hideWebchatState, isWidgetOpenState, isMobileState, } from '@/state/session';
import { ChatContainer } from '../ChatContainer/ChatContainer';
export const AppContainer = () => {
    const { openWidget } = useWidgetState();
    const socket = useSocketSetup();
    const { isEmbed, isLivechat, isPopup } = useRecoilValue(widgetPositionState);
    const widgetAlignment = useRecoilValue(widgetAlignmentSelector);
    const autoOpen = useRecoilValue(autoOpenSelector);
    const focusTrap = useRecoilValue(focusTrapSelector);
    const theme = useRecoilValue(themeSelector);
    const isOpen = useRecoilValue(isWidgetOpenState);
    const hideWebchat = useRecoilValue(hideWebchatState);
    const isMobile = useRecoilValue(isMobileState);
    useEffect(() => {
        if ((autoOpen && !isOpen) || isEmbed) {
            openWidget();
        }
    }, [autoOpen, isEmbed, isOpen, openWidget]);
    if (hideWebchat) {
        return null;
    }
    const getChatContainer = () => {
        if (isLivechat && !isMobile) {
            return (_jsxs(Popover, { open: isOpen, modal: true, children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(Launcher, {}) }), _jsx(PopoverContent, { align: widgetAlignment === 'left' ? 'start' : 'end', className: cn('border-none p-0', styles[theme]), children: _jsx(ChatContainer, {}) })] }));
        }
        if (isEmbed) {
            return (_jsx("div", { className: `${theme}-theme`, children: _jsx(ChatContainer, {}) }));
        }
        if (isPopup || isMobile) {
            const isDesktopPopup = isPopup && !isMobile;
            return (_jsxs(Dialog, { open: isOpen, children: [_jsx(DialogTrigger, { children: _jsx(Launcher, {}) }), _jsx(DialogContent, { onInteractOutside: (e) => e.preventDefault(), onEscapeKeyDown: (e) => e.preventDefault(), className: cn(styles[theme], 'h-full overflow-hidden p-0', isDesktopPopup &&
                            'h-[var(--moveo-chat-height)] w-[var(--moveo-expanded-chat-width)]', !isMobile &&
                            !isEmbed &&
                            'rounded-[var(--moveo-new-border-radius-base)]'), children: _jsx(ChatContainer, {}) })] }));
        }
    };
    return (_jsx(SocketContext.Provider, { value: socket, children: _jsxs("div", { className: cn('fixed inset-0 h-full w-full overflow-hidden', {
                'animate-[fadeIn_0.3s_forwards] bg-black/40': focusTrap && isOpen,
            }), children: [getChatContainer(), _jsx(IframeController, {})] }) }));
};
